import { selectUserAuthStatus } from '../state/userSlice';
import { useSelector } from 'react-redux';

const useAuthStatus = () => useSelector(selectUserAuthStatus);

export default useAuthStatus;
